import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async get ({ commit, dispatch }) {
    try {
      const { data } = await directus.getItem('site_config', 1)
      commit('setAttr', {
        name: 'model',
        value: data
      })
    } catch (err) {
      errorDirectus(err, dispatch)
    }
  }
}
